import { render, staticRenderFns } from "./CgThirdShelvesManage.vue?vue&type=template&id=a8c2f0ca&scoped=true"
import script from "./CgThirdShelvesManage.vue?vue&type=script&lang=js"
export * from "./CgThirdShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c2f0ca",
  null
  
)

export default component.exports